import type { IRequestOpts } from '@invent/shared-types';

// Written by CORE_DashboardHeader's currency switcher.
export const CURRENCY_STORAGE_KEY = 'user-currency';

export function withCurrencyParam(
  apiUrl: string,
  opts: IRequestOpts | undefined,
  apiBaseUrl: string | undefined,
  currency: string | null
): [string, IRequestOpts?] {
  if (!currency || !apiBaseUrl || !apiUrl.startsWith(apiBaseUrl)) {
    return [apiUrl, opts];
  }
  // http-client appends queryParams with a bare `?`, so a URL that already has one takes the param inline.
  if (apiUrl.includes('?')) {
    return [`${apiUrl}&currency=${currency}`, opts];
  }
  // Copy, never mutate: widgets reuse the same queryParams object in their query keys.
  return [
    apiUrl,
    {
      traceId: '',
      ...opts,
      params: { ...opts?.params, queryParams: { ...opts?.params?.queryParams, currency } }
    }
  ];
}
